import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { CorrectCustomer } from './components/CorrectCustomer';
import { CorePain } from './components/CorePain';
import { NewWay } from './components/NewWay';
import { Mechanism } from './components/Mechanism';
import { StrategicEvaluation } from './components/StrategicEvaluation';
import { Objections } from './components/Objections';
import { Authority } from './components/Authority';
import { WhoIsItFor } from './components/WhoIsItFor';
import { Differentiation } from './components/Differentiation';
import { Transformation } from './components/Transformation';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
// Botón flotante de WhatsApp — comentado temporalmente, se reactivará más adelante.
// import { StickyWhatsApp } from './components/StickyWhatsApp'
export function App() {
  return <div className="min-h-screen bg-slate-50 font-sans selection:bg-accent/30 selection:text-navy-900" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <Nav data-id="element-2" />

      <main data-id="element-3">
        <Hero data-id="element-4" />
        <CorrectCustomer data-id="element-5" />
        <CorePain data-id="element-6" />
        <NewWay data-id="element-7" />
        <Mechanism data-id="element-8" />
        <StrategicEvaluation data-id="element-9" />
        <Objections data-id="element-10" />
        <Authority data-id="element-11" />
        <WhoIsItFor data-id="element-12" />
        <Differentiation data-id="element-13" />
        <Transformation data-id="element-14" />
        <FinalCTA data-id="element-15" />
      </main>

      <Footer data-id="element-16" />
      {/* Botón flotante de WhatsApp — desactivado temporalmente.
            Reactivar descomentando el import y la línea siguiente.
        <StickyWhatsApp /> */}
    </div>;
}